import { render, staticRenderFns } from "./BolsaFamilia.vue?vue&type=template&id=c2b20220"
import script from "./BolsaFamilia.vue?vue&type=script&lang=js"
export * from "./BolsaFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports